import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { APIRoutes } from '../global-misc/api-routes';
import { firstValueFrom } from 'rxjs';
import { CreateTreatmentModel, TreatmentMethodModel, TreatmentModel, UpdateTreatmentModel } from '../global-data-models/treatment.model';

@Injectable({ providedIn: 'root' })
export class TreatmentService {
  constructor(private http: HttpClient) { }

  public async getTreatmentMethods(): Promise<TreatmentMethodModel[]> {
    const apiRoute = APIRoutes.TREATMENT_METHOD_ROUTE;
    const response: TreatmentMethodModel[] = await firstValueFrom(this.http.get<TreatmentMethodModel[]>(apiRoute));
    return response;
  }

  public async createPatientTreatment(orgId: string, patientId: string, treatment: CreateTreatmentModel): Promise<TreatmentModel> {
    const apiRoute = APIRoutes.PATIENT_TREATMENTS_ROUTE.replace(":patientId", patientId).replace(':orgId', orgId);
    const response: TreatmentModel = await firstValueFrom(this.http.post<TreatmentModel>(apiRoute, treatment));
    return response;
  }

  public async getPatientTreatments(orgId: string, patientId: string): Promise<TreatmentModel[]> {
    const apiRoute = APIRoutes.PATIENT_TREATMENTS_ROUTE.replace(':patientId', patientId).replace(':orgId', orgId);
    const response: TreatmentModel[] = await firstValueFrom(this.http.get<TreatmentModel[]>(apiRoute));
    return response;
  }

  public async getPatientTreatment(orgId: string, patientId: string, treatmentId: string): Promise<TreatmentModel> {
    const apiRoute = APIRoutes.PATIENT_SINGLE_TREATMENT_ROUTE.replace(':patientId', patientId).replace(':orgId', orgId).replace(":treatmentId", treatmentId);
    const response: TreatmentModel = await firstValueFrom(this.http.get<TreatmentModel>(apiRoute));
    return response;
  }

  public async updatePatientTreatment(orgId: string, patientId: string, treatmentId: string, body: UpdateTreatmentModel): Promise<TreatmentModel> {
    const apiRoute = APIRoutes.PATIENT_SINGLE_TREATMENT_ROUTE.replace(':patientId', patientId).replace(':orgId', orgId).replace(":treatmentId", treatmentId);
    const response: TreatmentModel = await firstValueFrom(this.http.patch<TreatmentModel>(apiRoute, body));
    return response;
  }

  public async deletePatientTreatment(orgId: string, patientId: string, treatmentId: string): Promise<TreatmentModel> {
    const apiRoute = APIRoutes.PATIENT_SINGLE_TREATMENT_ROUTE.replace(':patientId', patientId).replace(':orgId', orgId).replace(":treatmentId", treatmentId);
    const response: TreatmentModel = await firstValueFrom(this.http.delete<TreatmentModel>(apiRoute));
    return response;
  }
}
